export default function TextInput({ title, ...attributes }) {
    return (
        <div>
            <label className="block text-md font-normal text-gray-600 mb-0">
                {title}
            </label>
            <input
                type="text"
                className="w-full border border-gray-800 rounded h-9  focus:outline-offset-2  outline-blue-500/50 px-2 py-2 text-gray-600"
                {...attributes}
            />
        </div>
    );
}
